import Wow from 'wowjs';
export default () => ({
    init() {
        const w = Wow.WOW;
        const cz = new w({
          animateClass: 'animate__animated'
        }).init();
    },
});
